const initialState = {
  status: "closed",
  name: "",
};

const donationNotificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_DONATION_NOTIFICATION_STATUS":
      return {
        ...state,
      };
    case "UPDATE_DONATION_NOTIFICATION_STATUS":
      return {
        ...state,
        status: action.data,
      };
    case "ADD_DONATION_TEAM_NAME_TO_NOTIFICATION":
      return {
        ...state,
        name: action.data,
      };
    default:
      return state;
  }
};

export default donationNotificationsReducer;
